import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#002D62]/90 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <Link to="/" className="flex items-center gap-2">
            <motion.img 
              src="/src/assets/images/world.svg" 
              alt="Logo" 
              className="h-8 w-8" 
              whileHover={{ rotate: 360 }}
              transition={{ duration: 1 }}
            />
            <span className={`text-xl font-bold ${scrolled ? 'text-white' : 'text-white'}`}>
              MultiLingua
            </span>
          </Link>
        </motion.div>
        
        <motion.nav
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <ul className="flex gap-6">
            <li>
              <Link 
                to="/" 
                className={`hover:text-[#00AEEF] transition-colors ${scrolled ? 'text-white' : 'text-white'}`}
              >
                Accueil
              </Link>
            </li>
            <li>
              <a 
                href="#about" 
                className={`hover:text-[#00AEEF] transition-colors ${scrolled ? 'text-white' : 'text-white'}`}
              >
                À propos
              </a>
            </li>
            <li>
              <a 
                href="#contact" 
                className={`hover:text-[#00AEEF] transition-colors ${scrolled ? 'text-white' : 'text-white'}`}
              >
                Contact
              </a>
            </li>
          </ul>
        </motion.nav>
      </div>
    </motion.header>
  );
};

export default Header;
